import { EmailMessage, EmailMessageHeader } from '../../types/entities';
import { cleanEntityString } from '../../providers/provider/defaults';

/** The two populations `email_message` holds. See `EmailMessage::CHANNEL_*` in HQ-API. */
export const emailMessageChannels: { id: string, name: string }[] = [
    { id: 'nok_mini', name: 'Nok Mini' },
    { id: 'sales', name: 'Sales' },
];

/**
 * Every status either channel writes. `new` is unread on both; the Nok pipeline then marks a
 * message `opened`, the sales screen marks it `read`.
 */
export const emailMessageStatusChoices: { id: string, name: string }[] = [
    { id: 'new', name: 'New' },
    { id: 'opened', name: 'Opened' },
    { id: 'read', name: 'Read' },
];

/**
 * The stored headers as one list, whatever shape they were stored in.
 *
 * Inbound mail stores MailGun's header list as `{ key, value }` pairs, which keeps repeated headers
 * (`Received` appears many times). Outbound Nok mail stores a plain map built by the sender.
 */
export const headersOf = (record: Pick<EmailMessage, 'headers'>): EmailMessageHeader[] => {
    const headers: EmailMessage['headers'] = record.headers;
    if (Array.isArray(headers)) {
        return headers
            .filter((header: EmailMessageHeader): boolean => header != null && typeof header === 'object')
            .map((header: EmailMessageHeader): EmailMessageHeader => ({
                key: String(header.key ?? ''),
                value: String(header.value ?? ''),
            }));
    }
    if (headers != null && typeof headers === 'object') {
        return Object.keys(headers).map((key: string): EmailMessageHeader => ({
            key,
            value: String(headers[key] ?? ''),
        }));
    }

    return [];
};

/** A relation IRI as the bare id HQ routes use, or null when there is no relation. */
export const idFromIri = (iri: string|null|undefined, prefix: string): string|null => {
    if (iri == null || iri === '') {
        return null;
    }

    return cleanEntityString(iri, prefix);
};
